import urlJoin from 'url-join';

import {BITMOVIN_API_BASE_PATH} from '../apiConfig';
import HttpService from '../http';

import {WrapperAppSalesDemos} from './entities';

class FrontendService {
  private constructor() {}

  public static fetchSalesDemos(apiKey: string): Promise<WrapperAppSalesDemos> {
    const url = urlJoin(BITMOVIN_API_BASE_PATH, '/frontend/sales-demos');
    return HttpService.authorizedGet(url, apiKey, false, {});
  }
}

export default FrontendService;
